/* eslint-disable react/jsx-no-target-blank */
import { IWebAppUrl } from 'interfaces/webAppUrl';
import React from 'react';
import styles from './index.module.scss';

const ItemWebURL = (props: IWebAppUrl) => {
  const {
    labelText,
    url,
    customClass,
  } = props;
  
  return (
    <div className={`${styles['item-link']} ${customClass}`}>
      <div className={styles['label']}>{labelText}</div>
      <a href={url} target={'_blank'}>
        {url}
      </a> 
    </div>
  );
};

export default ItemWebURL;